<template>
  <div class="container" v-if="model">
    <common-head></common-head>
    <div class="inner">
      <div class="c-them-body">
        <div class="dz-detail-page">
          <div class="basic-info">
            <div class="img">
              <!-- <div class="img-tag1">
              {{ model.SOURCEOPENTYPE == "01" ? "借阅" : "畅读" }}
            </div> -->
              <template v-if="model.Cover"><img :src="model.Cover" /></template>
              <template v-else><img src="/static/img/np-img.png" /></template>
              <!-- <span class="img-tag">{{ model.ProductTypeText }}</span> -->
            </div>

            <div class="info">
              <div class="bkname">{{ model.Name }}</div>
              <div class="para-list">
                <ul>
                  <li>
                    Author：
                    <el-tooltip placement="top">
                      <template #content> {{ model.Author }}</template>
                      <span>{{ model.Author }}</span>
                    </el-tooltip>
                  </li>
                  <li>
                    Publisher：
                    <el-tooltip placement="top">
                      <template #content> {{ model.Publisher }}</template>
                      <span>{{ model.Publisher }}</span>
                    </el-tooltip>
                  </li>
                  <li>ISBN：{{ model.Isbn }}</li>
                  <li>PublisherTime：{{ model.PublishTime }}</li>
                  <li>Page views：{{ model.BrowseCount }} 次</li>
                  <li v-show="false">Online time：{{ model.CreatedTime }}</li>
                  <li>
                    Category：
                    <a :href="'/categry?form=' + model.ProductType">{{
                      model.ProductTypeText
                    }}</a>
                    >
                    <a :href="'/categry?form=' +
                        model.ProductType +
                        '&node=' +
                        model.CategryFirstId
                        ">{{ model.CategryFirstName }}</a>
                    >
                    <a :href="'/categry?form=' +
                      model.ProductType +
                      '&node=' +
                      model.CategryFirstId +
                      '&menu=' +
                      model.CategrySecondId
                      ">{{ model.CategrySecondName }}</a>
                  </li>
                </ul>
              </div>
              <div class="opt-info" v-if="flag == 1">
                <el-button slot="reference" type="warning" @click="jy(model.jy)">
                  {{ model.jy ? "归还" : "借阅" }}
                </el-button>

                <el-button type="warning" @click="GoToOpt(1, '')" v-if="model.jy">阅读</el-button>
              </div>
              <div class="opt-info" v-if="flag == 2">
                <el-button type="warning" @click="GoToOpt(1, '')">Now Reading</el-button>
                <el-button :type="model.IsCollect ? 'danger' : 'warning'" @click="$fun.addCollect(model)"
                  v-show="accountShow">{{ model.IsCollect
                    ? "- Book shelf" : "+ Book shelf" }}</el-button>
                <el-popover placement="bottom" width="160" trigger="click" popper-class="phone-btn" class="button-code"
                  v-show="false">
                  <slot>
                    <div class="code-info">
                      <div ref="qrCodeDiv" id="qrCode"></div>
                      <div class="ti">Mobile phone view</div>
                    </div>
                  </slot>
                  <el-button slot="reference" @click="GoToOpt(5, '')">
                    <span class="icon iconfont icon-shouji"></span>
                    Mobile phone view
                  </el-button>
                </el-popover>
              </div>
              <div class="opt-info" v-if="flag == 0">
                <el-button type="warning">加入心愿单</el-button>
                <el-button type="warning">试读</el-button>
              </div>
            </div>
          </div>
          <!-- <div class="intro-group">
          <el-tabs>
            <el-tab-pane
              v-for="(item, index) of tabsData"
              :key="item.Name"
              :name="index + ''"
              :label="item.Name"
            >
              <div
                class="contents"
                :class="tabsShow ? 'open' : ''"
                v-html="item.Text"
              ></div>
              <div
                class="more"
                v-if="
                  item.Text.split('<br />').length > 3 || item.Text.length > 489
                "
                @click="tabsShow = !tabsShow"
              >
                <span
                  class="icon iconfont"
                  :class="
                    tabsShow
                      ? 'icon-sanjiaoxingjiantou_xiangshang'
                      : 'icon-sanjiaoxingjiantou_xiangyou'
                  "
                ></span>
                {{ tabsShow ? "收起" : "展开" }}
              </div>
            </el-tab-pane>
          </el-tabs>
        </div> -->
          <!-- <div class="chapter-con">
          <div class="chapter-cc">
            <div class="chapter-hd">
              <div class="title">
                目录(<span>{{ pageTotal }}</span
                >章)
              </div>
              <div class="opt-set" @click="changeSort">
                {{ isAsc ? "倒序" : "升序"
                }}<span class="icon iconfont icon-paixu"></span>
              </div>
            </div>
            <div class="chapter-bd">
              <div class="chapter-list">
                <div
                  class="item"
                  v-for="(item, index) of data"
                  :key="item.id"
                  :index="index"
                >
                  <a href="javascript:void(0)" @click="GoToOpt(1, item.PAGE)">{{
                    item.CATALOGNAME
                  }}</a>
                </div>
              </div>
              <el-pagination
                class="m-page-list"
                background
                @size-change="sizeChange"
                @current-change="pageChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="prev, pager, next, jumper, total, sizes"
                :total="pageTotal"
              >
              </el-pagination>
            </div>
          </div>
          <div class="hotcc-r">
            <hot-recom></hot-recom>
          </div>
        </div> -->
          <div class="chapter-con"><hot-recom></hot-recom></div>

        </div>
      </div>
    </div>
    <common-foot></common-foot>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
import HotRecom from "common/other/HotRecom";
import QRCode from "qrcodejs2";
import { f } from "vue-carousel-3d";
export default {
  name: "dzDetail",
  components: {
    CommonHead,
    CommonFoot,
    HotRecom,
  },
  data: function () {
    return {
      model: undefined,
      data: [],
      pageNo: 1,
      pageSize: 30,
      pageTotal: 0,
      flag: 5,
      isAsc: "",
      tabsData: [],
      tabsShow: false,
      accountShow: false,
    };
  },
  mounted: function () {
    this.$bti
      .GetPCEbookInfo({
        ID: this.$route.params.id,
        ORGID: this.http.GetOrgInfo().OrgId,
      })
      .then((res) => {
        if (res.code != 1) {
          this.$router.push({ name: "Home", params: { message: res.data } });
          return;
        }
        this.model = res.data;
        if (this.model.Introduction != null && this.model.Introduction != " ") {
          this.tabsData.push({
            Name: "书籍简介",
            Text: this.model.Introduction.replace(/\\r/g, ""),
          });
        }
        if (this.model.Remark != null && this.model.Remark != " ") {
          this.tabsData.push({
            Name: "编者推荐",
            Text: this.model.Remark.replace(/\\r/g, ""),
          });
        }
        if (this.model.AuthorInfo != null && this.model.AuthorInfo != " ") {
          this.tabsData.push({
            Name: "作者简介",
            Text: this.model.AuthorInfo.replace(/\\r/g, ""),
          });
        }
        if (this.model.Digest != null && this.model.Digest != " ") {
          this.tabsData.push({
            Name: "精彩书摘",
            Text: this.model.Digest.replace(/\\r/g, ""),
          });
        }
        if (this.model.Preface != null && this.model.Preface != " ") {
          this.tabsData.push({
            Name: "前言",
            Text: this.model.Preface.replace(/\\r/g, ""),
          });
        }
        this.$fun.browse(this.model.Id, this.model.ProductType, (res) => {
          this.model.BrowseCount = res.data;
        });
        this.$bti.GetAddXyd({ BOOKID: this.model.Id, ISDELETED: this.model.ProductType }).then((res) => {
          this.flag = res.data
        });
        this.loadData();
      });

    //如果不是ip免登录用户则显示加入书架按钮
    let userid = this.jwt_decode(window.localStorage.Token).userId;
    if (userid != '13400000001') {
      this.accountShow = true;
    }

  },
  methods: {
    loadData: function () {
      var params = {
        page: this.pageNo,
        rows: this.pageSize,
        wheres: {
          EBOOKID: this.model.BookId,
          isAsc: this.isAsc,
        },
      };
      this.$bti.GetCataloguePage(params).then((res) => {
        this.data = res.data.rows;
        this.pageTotal = res.data.total;
      });
    },
    pageChange: function (val) {
      this.pageNo = val;
      this.loadData();
    },
    sizeChange: function (val) {
      this.pageSize = val;
      this.loadData();
    },
    changeSort: function () {
      if (this.isAsc === "") {
        this.isAsc = "false";
      } else {
        this.isAsc = "";
      }
      this.pageNo = 1;
      this.loadData();
    },
    GoToOpt: function (val, page) {
      if (val == 1) {
        this.$fun.openJdReadBook(this.model.Id, this.model.BookId, "2", page);
      } else if (val == 5) {
        var own = this;
        this.$fun.openJdReadBook(
          this.model.Id,
          this.model.BookId,
          "2",
          "",
          function (res) {
            const codeHtml = document.getElementById("qrCode");
            codeHtml.innerHTML = "";
            let qrcodeCreater = new QRCode(own.$refs.qrCodeDiv, {
              text: res.data,
              width: 130,
              height: 130,
              colorDark: "#333333", // 二维码颜色
              colorLight: "#ffffff", // 二维码背景色
              correctLevel: QRCode.CorrectLevel.M, // 容错率，L/M/H
            });
            qrcodeCreater._el.title = "";
          }
        );
      }
    },
    jy(flag) {
      if (this.$fun.isLogin()) {
        if (flag) {
          var params = {
            STATUS: 1,
            BOOKID: this.model.Id,
          };
          this.$bti.ReadyBook(params).then((res) => {
            if (res.code == 1) {
              this.$message.success("归还成功!");
              this.model.jy = false;
            }
          });
        } else {
          var params = {
            STATUS: 0,
            BOOKID: this.model.Id,
          };
          this.$bti.ReadyBook(params).then((res) => {
            if (res.code == 1) {
              this.$message.success("借阅成功!");
              this.model.jy = true;
            } else {
              this.$message.error(res.data);
            }
          });
        }
      } else {
        window.location.href = "/login?redirect=" + window.location.pathname;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.dz-detail-page {
  position: relative;
  background: #fff;
  padding: 50px 0px 50px 50px;
  /* margin-bottom: 50px; */
}

.c-them-body {
  padding: 30px 0px;
}

.basic-info:after,
.basic-info .para-list ul:after,
.chapter-con:after,
.chapter-con .chapter-cc .chapter-hd,
.chapter-list:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.basic-info {
  margin-right: 50px;
}

.basic-info .img {
  float: left;
  width: 197px;
  height: 267px;
  box-shadow: 0px 0px 5px #ccc;
  position: relative;
}

.basic-info .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.basic-info .info {
  position: relative;
  float: right;
  width: 863px;
  width: calc(100% - 237px);
  min-height: 267px;
}

.basic-info .bkname {
  font-size: 24px;
  color: #252525;
  font-weight: bold;
}

.basic-info .para-list {
  padding: 20px 0;
}

.basic-info .para-list ul li {
  float: left;
  width: 50%;
  font-size: 18px;
  padding: 5px 25px 5px 0px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.basic-info .opt-info {
  position: relative;
  bottom: 0px;
  left: 0;
}

.basic-info .opt-info .el-button {
  font-weight: bold;
}

.basic-info .opt-info .button-code {
  padding-left: 10px;
}

.code-info {
  width: 134px;
  text-align: center;
}

.code-info img {
  width: 134px;
  height: 134px;
  object-fit: cover;
}

.code-info .ti {
  padding-top: 10px;
  color: #fff;
}

.intro-group {
  padding: 40px 0 20px 0px;
  margin-right: 50px;
}

.chapter-con {
  position: relative;
  min-height: 840px;
}

.chapter-con .chapter-cc {
  float: left;
  width: 688px;
}

.chapter-con .chapter-cc .chapter-hd {
  position: relative;
  height: 52px;
  line-height: 52px;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 2px solid #e4e7ed;
  visibility: visible;
  overflow: inherit;
}

.chapter-con .chapter-cc .chapter-hd .title {
  float: left;
  width: auto;
  height: 52px;
  color: #303133;
  visibility: visible;
  border-bottom: 4px solid #ed7d31;
}

.chapter-con .chapter-cc .chapter-hd .opt-set {
  position: absolute;
  right: 0;
  top: 0;
  visibility: visible;
  font-weight: normal;
  cursor: pointer;
}

.chapter-con .chapter-cc .chapter-bd {
  padding: 15px;
  margin-bottom: 15px;
}

.chapter-list .item {
  float: left;
  width: 45%;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.chapter-list .item a {
  font-size: 14px;
  color: #666;
}

.chapter-list .item:nth-of-type(odd) {
  margin-right: 5%;
}

.hotcc-r {
  position: absolute;
  right: 0;
  top: auto;
  width: 408px;
  height: 820px;
  background: #f6f6f6;
}

#qrCode {
  display: inline-block;
  margin: 0 auto;
  /*水平居中*/
  position: relative;
  top: 15%;
}

#qrCode img {
  width: 200px;
  height: 200px;
  background-color: #fff;
  padding: 6px;
}

.basic-info .img .img-tag1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg,
      #409eff,
      #409eff 50%,
      transparent 50%,
      transparent 100%);
  color: #fff;
  padding-left: 19px;
}

/* .basic-info ima .img-tag2{
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg,#409EFF,#409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
} */
</style>



// WEBPACK FOOTER //
// src/pages/detail/dzDetail.vue